import camelcaseKeys from 'camelcase-keys';
export var transformPublicationsResponse = function (response) {
    var safeJsonParse = function (jsonStr) {
        try {
            var result = JSON.parse(jsonStr);
            return result;
        }
        catch (_a) {
            return undefined;
        }
    };
    var parsedResponse = safeJsonParse(response.allPublications);
    return parsedResponse ? camelcaseKeys(parsedResponse, { deep: true }) : parsedResponse;
};
export var transformPublicationDetailsResponse = function (response) {
    var _a;
    var parsedResponse = camelcaseKeys(response, { deep: true });
    return (_a = parsedResponse === null || parsedResponse === void 0 ? void 0 : parsedResponse.getOwnerManualsDataResult) === null || _a === void 0 ? void 0 : _a.ownerManuals;
};
